export function mapBreathingStatus(status) {
  switch (status) {
    case "apnea":
      return "Apnea";
    case "hypopnea":
      return "Low";
    case "hyperpnea":
      return "High";
    case "normal":
      return "Normal";
    default:
      return "Unknown";
  }
}
